import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock } from "react-icons/fa";
import carImage from "../Assets/carLogin.jpg";
import { SITE_LOGO, SITE_LOGO_ALT } from "../Utils/imageUtils";
import { authApi, setAccessToken } from "../services/api";
import "./PartnerLogin.css";

export default function PartnerLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await authApi.login({ email: email.trim(), password });
      if (res.user?.role !== "partner") {
        setAccessToken(null);
        await authApi.logout().catch(() => {});
        setError("This account is not a partner login. Please use customer or admin sign-in.");
        return;
      }
      setAccessToken(res.accessToken);
      localStorage.setItem("partnerUser", JSON.stringify(res.user));
      navigate("/partner", { replace: true });
    } catch (err) {
      setError(err.message || "Login failed. Check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-login-page">
      <aside className="partner-login-visual" aria-hidden="true">
        <div
          className="partner-login-visual-bg"
          style={{ backgroundImage: `url(${carImage})` }}
        />
      </aside>

      <main className="partner-login-panel">
        <div className="partner-login-card">
          <div className="partner-login-card-head">
            <span className="partner-login-badge">Partner access</span>
            <img src={SITE_LOGO} alt={SITE_LOGO_ALT} className="partner-login-logo" />
            <h1>Welcome back</h1>
            <p>Sign in to your partner workspace</p>
          </div>

          {error ? <div className="partner-login-error">{error}</div> : null}

          <form onSubmit={submit}>
            <div className="partner-login-field">
              <label htmlFor="partner-email">Email address</label>
              <div className="partner-login-input-wrap">
                <FaEnvelope className="partner-login-input-icon" aria-hidden="true" />
                <input
                  id="partner-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@dealership.com"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="partner-login-field">
              <label htmlFor="partner-password">Password</label>
              <div className="partner-login-input-wrap">
                <FaLock className="partner-login-input-icon" aria-hidden="true" />
                <input
                  id="partner-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className="partner-login-submit" disabled={loading}>
              {loading ? "Signing in…" : "Sign in to Partner Panel"}
            </button>
          </form>

          <div className="partner-login-links">
            <Link to="/">← Back to website</Link>
            <Link to="/login" className="partner-login-link-accent">
              Customer login
            </Link>
            <Link to="/admin/login">Admin login</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
